import { createSuspenseQueryHook } from '../internal/createSuspenseQueryHook';
import { applications } from '../queries/applications';

/**
 * @deprecated Use `createQueryOptions` with `getApplication` and `useSuspenseQuery` directly.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const useSuspenseApplication = createSuspenseQueryHook(({ applicationKey }: { applicationKey: string }) =>
  applications.detail({ applicationKey }),
);
